// extracted by mini-css-extract-plugin
export default {"spin":"BeforeData_spin__JeDdb","empty":"BeforeData_empty__rq7AW"};